export default __webpack_public_path__ + "eb2602d1f44efe48628c1060e7b27875.jpg";